import {alias, createModelSchema} from "serializr";
import {SmartOfferBundle} from "../bundle-core/SmartOfferBundle";
import {SmartOfferBundleKind} from "../bundle-core/SmartOfferBundleKind";
import {RewardBunch} from "@/modules/redactor/models/reward/RewardBunch";
import {SmartOfferBundleCascadeType} from "./SmartOfferBundleCascadeType";
import {CurrencyKindModel} from "@/modules/redactor/models/currency/CurrencyKindModel";


export class SmartOfferBundleCascade extends SmartOfferBundle {

    constructor() {
        super(SmartOfferBundleKind.CASCADE);

        this._type = null;
        this._currency = null;
        this._reward = null;
    }

    get type() {
        return this._type;
    }

    set type(value) {
        this._type = value;
    }

    get currency() {
        return this._currency;
    }

    set currency(value) {
        this._currency = value;
    }

    get reward() {
        return this._reward;
    }

    set reward(value) {
        this._reward = value;
    }

    valid() {

        if (!SmartOfferBundleCascadeType.is(this.type) || SmartOfferBundleCascadeType.isNone(this.type)) {
            return false;
        }

        if (!CurrencyKindModel.is(this.currency)) {
            return false;
        }

        if (!this.reward || !this.reward.valid()) {
            return false;
        }

        return super.valid();
    }

    empty() {

        if (!this.reward || this.reward.empty()) {
            return true;
        }

        return super.empty();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SmartOfferBundleCascade());
        } else if (target instanceof SmartOfferBundleCascade) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SmartOfferBundleCascade, {
    _type: alias("type", SmartOfferBundleCascadeType.schema()),
    _currency: alias("currency", CurrencyKindModel.schema()),
    _reward: alias("reward", RewardBunch.schema())
});